/**
 * ==========================================================
 * NUPEP Subscription Experience
 * Version: 1.0.0
 * Compatible: Shopify Dawn + Appstle
 * ==========================================================
 */

document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('#nupep-subscription-card');

  if (!section) return;

  const purchaseOptions = [...section.querySelectorAll('.nupep-option')];
  const frequencyButtons = [...section.querySelectorAll('.nupep-frequency')];

  const savingsMessage = section.querySelector('.nupep-savings-message');

  /*
  ==========================================================
  Savings Messages
  ==========================================================
  */

  const savings = {
    30: {
      discount: 10,
      message: 'Save 10% on every recurring shipment.'
    },
    60: {
      discount: 15,
      message: 'Save 15% while receiving fewer shipments.'
    },
    90: {
      discount: 20,
      message: 'Maximum savings with 20% off every delivery.'
    }
  };

  /*
  ==========================================================
  Purchase Option Toggle
  ==========================================================
  */

  purchaseOptions.forEach(option => {

    option.addEventListener('click', () => {

      purchaseOptions.forEach(item => {
        item.classList.remove('active');
      });

      option.classList.add('active');

      option.querySelector('input').checked = true;

      syncPurchaseOption(option);

    });

  });

  /*
  ==========================================================
  Frequency Selector
  ==========================================================
  */

  frequencyButtons.forEach(button => {

    button.addEventListener('click', () => {

      frequencyButtons.forEach(item => {
        item.classList.remove('active');
      });

      button.classList.add('active');

      const frequency = button.dataset.frequency;

      updateSavings(frequency);

      syncSellingPlan(frequency);

    });

  });

  /*
  ==========================================================
  Savings Display
  ==========================================================
  */

  function updateSavings(days) {

    if (!savings[days]) return;

    savingsMessage.textContent = savings[days].message;

  }

  /*
  ==========================================================
  Sync Purchase Option
  ==========================================================
  */

  function syncPurchaseOption(option) {

    const value = option.querySelector('input').value;

    /*
    ----------------------------------------------------------
    Placeholder

    Later this will communicate directly
    with the Appstle widget.

    Example:

    if(value==="subscription"){
        Appstle.selectSubscription();
    }

    ----------------------------------------------------------
    */

    console.log('Purchase option:', value);

  }

  /*
  ==========================================================
  Sync Selling Plan
  ==========================================================
  */

  function syncSellingPlan(days) {

    /*
    ----------------------------------------------------------
    Placeholder

    Later we will locate Appstle's selling-plan
    selector and automatically choose:

    30 Days

    60 Days

    90 Days

    ----------------------------------------------------------
    */

    console.log('Selected frequency:', days);

  }

  /*
  ==========================================================
  Initialization
  ==========================================================
  */

  updateSavings(30);

});